import ModalKitchenCancelUnit from "../../../components/modals/ModalKitchenCancelUnit";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { kitchenHandler } from "../../../redux/handlers";
import CustomBtn from "components/fragments/CustomBtn";
import { useParams } from "react-router-dom";
import { useKitchen } from "../../../components/kitchen/KitchenContext";
import moment from "moment";
import { original } from "@reduxjs/toolkit";
export default function KitchenPage() {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const kitchenCardData = useSelector((state) => state.kitchen.kitchenCard);
  const kitchenSocket = useSelector((state) => state.kitchen.kitchenSocket);
  const [isPayment, setIsPayment] = useState(true);
  const [modalKitchenCancelOpen, setModalKitchenCancelOpen] = useState(false);
  const [seletedUnitsObj, setSeletedUnitsObj] = useState(null);
  const branchID = localStorage.getItem("branchId");
  const kitchenID = localStorage.getItem("branchKitchenId");
  const [kitchenData, setKitchenData] = useState([]);
  const [cancelOrderList, setCancelOrderList] = useState([]);
  const { setKitchenCount } = useKitchen();
  const audioRef = useRef(null);

  const checkDisabled = (indexList, foodList, unit) => {
    if (indexList.length === 0) {
      return false;
    }

    return false;
  };

  const checkIsSelectMutiple = (indexList, foodList) => {
    return true;
  };

  const playNotification = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((e) => {
        console.warn("audio failed to play: ", e);
      });
    }
  };

  //dispatch seconds params should not be fixed in staging or prod
  const syncAfterHandle = async () => {
    await dispatch(
      kitchenHandler.getKitchenCard(businessSlug, branchID, kitchenID)
    );
  };

  useEffect(() => {
    dispatch(kitchenHandler.getKitchenCard(businessSlug, branchID, kitchenID));
  }, [dispatch, branchID, businessSlug, kitchenID, cancelOrderList]);

  useEffect(() => {
    const updateFormat = kitchenCardData.map((item) => {
      const date = moment(item.created_at);
      const currentTime = date.format("hh:mm:ss");
      return {
        id: item.id,
        type:
          item.order_type === "DINE_IN"
            ? 1
            : item.order_type === "TAKEAWAY"
            ? 2
            : 3,
        name: item.table,
        orderId: item.order_id,
        posName: item.branch_pos,
        remark: item.order.remark,
        time: currentTime,
        queue: item.queue || "",
        billStatus:
          item.bill && item.bill.length > 0 ? item.bill[0].status : "PENDING",
        orderItem: item.orderItems.map((order) => ({
          id: order.id,
          name: order.name,
          originalUnit: Number(order.quantity),
          unit: Number(order.quantity) - Number(order.quantity_removed),
          prevUnit:
            order.quantity_removed === 0 ? null : order.quantity_removed,
          productType: order.product_type ?? "GENERAL",
          bundleItems: (order.bundleItems ?? []).map((item) => item.name),
          addOnList: [
            ...order.productOption.map((item) => item.name),
            ...order.specificOption.map((item) => item.name),
          ],
          ignoreList: order.annotation.map((item) => item.name),
          isCancel:
            Number(order.quantity) - Number(order.quantity_removed) === 0,
          maxUnit: Number(order.quantity),
        })),
      };
    });

    const updatedItem = updateFormat.map((card) => {
      const newCard = { ...card, orderItem: [...card.orderItem] };

      cancelOrderList?.forEach((item) => {
        if (item.id === card.id) {
          const foodIndex = newCard.orderItem.findIndex(
            (food) => food.id === item.foodId
          );

          if (foodIndex !== -1) {
            newCard.orderItem[foodIndex] = {
              ...newCard.orderItem[foodIndex],
              ...item.info,
            };
          }
        }
      });

      return newCard;
    });
    setKitchenCount(updateFormat?.length);
    setKitchenData(updatedItem);
  }, [kitchenCardData, setKitchenCount, cancelOrderList]);

  useEffect(() => {
    async function updateKitchenOrder() {
      if (kitchenSocket) {
        await dispatch(
          kitchenHandler.getKitchenCard(businessSlug, branchID, kitchenID)
        );
        playNotification();
      }
    }
    updateKitchenOrder();
  }, [branchID, businessSlug, dispatch, kitchenID, kitchenSocket]);

  const removeItemFromTempState = (cardID, foodID) => {
    const filtered = cancelOrderList.filter(
      (item) => !(item.id === cardID && item.foodID === foodID)
    );
    setCancelOrderList(filtered);
  };
  return (
    <>
      {/* header */}

      {/* body */}
      <div className="flex gap-[min(2.15vw,22px)] px-[min(1.56vw,16px)]  pt-[min(1.56vw,16px)] pb-[min(7.13vw,73px)] min-h-[calc(100vh-90px)]">
        {kitchenData?.map((item, index) => {
          return (
            <div className="" key={index}>
              <KitchenCard
                cardInfo={item}
                setSeletedUnitsObj={setSeletedUnitsObj}
                setModalKitchenCancelOpen={setModalKitchenCancelOpen}
                checkIsSelectMutiple={checkIsSelectMutiple}
                isPayment={isPayment}
                checkDisabled={checkDisabled}
                syncAfterHandle={syncAfterHandle}
                removeItemFromTempState={removeItemFromTempState}
              />
            </div>
          );
        })}
      </div>
      <audio ref={audioRef} src="/notification.mp3" preload="auto"></audio>
      <ModalKitchenCancelUnit
        modalOpenObj={{
          modalOpen: modalKitchenCancelOpen,
          setModalOpen: setModalKitchenCancelOpen,
        }}
        seletedUnitsObj={seletedUnitsObj}
        cancelOrderListObj={{
          itemList: cancelOrderList,
          setItemList: setCancelOrderList,
        }}
        syncAfterHandle={syncAfterHandle}
        businessSlug={businessSlug}
      />
    </>
  );
}

function KitchenCard({
  cardInfo,
  setSeletedUnitsObj,
  removeItemFromTempState,
  setModalKitchenCancelOpen,
  checkIsSelectMutiple,
  isPayment,
  checkDisabled,
  syncAfterHandle,
}) {
  const [indexList, setIndexList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  useEffect(() => {
    const arrayOrder = cardInfo?.orderItem;
    setOrderList(arrayOrder);
  }, [cardInfo]);

  return (
    <>
      <div className="shadow-2-8 w-[min(38.81vw,325px)] bg-[#FFF] h-fit rounded-[14px] overflow-hidden ">
        {/* <div className="rounded-t-[min(0.39vw,4px)] flex  justify-between  pl-[min(1.37vw,14px)] mb-2 pr-[min(0.39vw,10px)] pt-[10px] pb-[min(0.68vw,7px)]">
         */}
        <div
          className={
            cardInfo?.type == 1
              ? "rounded-t-[min(0.39vw,4px)] flex justify-between bg-[var(--color-orange)] pl-[min(1.37vw,14px)] pr-[min(0.39vw,4px)] pt-[min(0.39vw,4px)] pb-[min(0.68vw,7px)]"
              : cardInfo?.type == 2
              ? "rounded-t-[min(0.39vw,4px)] flex items-end justify-between bg-[var(--color-blue)] pl-[min(1.37vw,14px)] pr-[min(0.39vw,4px)] pt-[min(0.39vw,4px)] pb-[min(0.68vw,7px)]"
              : "rounded-t-[min(0.39vw,4px)] flex items-end justify-between bg-[var(--color-green)] pl-[min(1.37vw,14px)] pr-[min(0.39vw,4px)] pt-[min(0.39vw,4px)] pb-[min(0.68vw,7px)]"
          }
        >
          <div className="flex flex-wrap  w-100 pb-[2px] pt-[14px] items-start gap-[min(1.17vw,12px)]">
            <img
              className="object-contain aspect-square w-[min(6.54vw,40px)] h-fit"
              src={`${
                cardInfo?.type === 1
                  ? "/img/icons/icon-kitchen-onsite.png"
                  : cardInfo?.type === 2
                  ? "/img/icons/icon-kitchen-take-home.png"
                  : "/img/icons/icon-kitchen-delivery.png"
              }`}
              alt=""
            />
            <div className=" font-[500]">
              <div className="text-base text-[#FFF] lh-1 bg mb-1">
                {cardInfo?.type === 1
                  ? "ทานที่ร้าน"
                  : cardInfo?.type === 2
                  ? "ซื้อกลับบ้าน"
                  : "เดลิเวอรี่"}
              </div>
              <div className="font-[500]">
                <span className="text-base text-[#FFF]">
                  {cardInfo?.type === 1 ? `ในร้าน ${cardInfo?.name || ""}` : ``}
                  {` คิวที่ `}{" "}
                  <span className="text-[24px] pl-2">{`${cardInfo?.queue}`}</span>
                </span>
                <span className="text-base text-[#FFF] ml-2">
                  {cardInfo?.remark ? `(${cardInfo?.remark})` : ""}
                </span>
              </div>
            </div>
            {cardInfo?.billStatus === "COMPLETED" ? (
              <div className="text-[#2DC76D] text-[14px] rounded-xl bg-[#DCFFEB] px-2 py-1 lh-1 ml-auto mr-2">
                ชำระเงินแล้ว
              </div>
            ) : cardInfo?.billStatus === "PENDING" ? (
              <div className="text-[#F59E0B] text-[14px] rounded-xl bg-[#FEF3C7] px-2 py-1 lh-1 ml-auto mr-2">
                รอชำระเงิน
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="flex pt-2 items-end text-base text-[#37474F]/[0.7] pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)] justify-between">
          <div className="mt-[1rem]">Order {cardInfo?.orderId}</div>

          <div className="space-y-1 ">
            <div className="">{cardInfo?.posName}</div>
            <div className="text-end">{cardInfo?.time}</div>
          </div>
        </div>

        <div className="font-semibold text-base pl-[min(1.37vw,14px)] pr-[min(1.79vw,15px)]">
          รายการอาหาร
        </div>

        <div className="overflow-y-auto flex flex-col gap-[min(1.56vw,16px)] max-h-[min(43.65vw,447px)] px-[min(1.95vw,20px)] pt-[min(1.95vw,20px)] pb-[min(3.32vw,34px)]">
          {orderList?.map((value, index) => {
            return (
              !value.isServ && (
                <FoodChild
                  key={index}
                  index={index}
                  info={value}
                  selectedIndexList={indexList}
                  setSelectedList={setIndexList}
                  foodList={orderList}
                  setFoodList={setOrderList}
                  isCancel={value.isCancel}
                  isDisabled={checkDisabled(indexList, orderList, value.unit)}
                  isSelectOneMode={false}
                  setSeletedUnitsObj={setSeletedUnitsObj}
                  cardId={cardInfo?.id}
                  selectedList={indexList}
                  syncAfterHandle={syncAfterHandle}
                  removeItemFromTempState={removeItemFromTempState}
                />
              )
            );
          })}
        </div>
        <FooterCard
          selectedList={indexList}
          setSelectedList={setIndexList}
          setFoodList={setOrderList}
          checkIsSelectMutiple={checkIsSelectMutiple}
          setModalKitchenCancelOpen={setModalKitchenCancelOpen}
          foodList={orderList}
          isPayment={isPayment}
          cardId={cardInfo?.id}
          syncAfterHandle={syncAfterHandle}
          setSeletedUnitsObj={setSeletedUnitsObj}
        />
      </div>
    </>
  );
}

function FoodChild({
  selectedIndexList,
  setSelectedList,
  foodList,
  setFoodList,
  setSeletedUnitsObj,
  index,
  info,
  isCancel = false,
  isDisabled = false,
  isSelectOneMode = false,
  cardId,
  syncAfterHandle,
  removeItemFromTempState,
}) {
  const { businessSlug } = useParams();
  const [isServ, setIsServ] = useState(false);
  const [icon, setIcon] = useState("/img/icons/icon-serv-grey.svg");
  const dispatch = useDispatch();
  const thisItemCancel = foodList[index].isCancel || false;
  const currentOrder = foodList[index];
  const handleClick = async (item) => {
    if (thisItemCancel) {
      const data = { quantity_removed_append: item };
      await dispatch(
        kitchenHandler.handleCancelingOrderItem(
          businessSlug,
          data,
          currentOrder.id
        )
      );
      await syncAfterHandle();
    } else {
      await dispatch(
        kitchenHandler.handleCompleteOrderItem(businessSlug, currentOrder.id)
      );
      await syncAfterHandle();
    }
    setSelectedList((prev) => {
      const oldList = [...prev];
      if (oldList.includes(index)) {
        return oldList
          .filter((item) => item !== index)
          .map((item) => (item > index ? item - 1 : item));
      }
      return [...oldList, index];
    });
    removeItemFromTempState(cardId, currentOrder.id);
  };
  useEffect(() => {
    if (isCancel) {
      return setIcon("/img/icons/icon-serv-red.svg");
    }
    if (selectedIndexList.includes(index)) {
      return setIcon("/img/icons/icon-serv-green.svg");
    }
    setIcon("/img/icons/icon-serv-grey.svg");
  }, [selectedIndexList, isCancel, index]);

  return (
    <div
      className={`flex justify-between text-[#4A4A4A] text-18 ${
        isDisabled && !isCancel ? " opacity-50" : ""
      }`}
    >
      <div
        className="flex leading-[1.2]"
        style={{ cursor: "pointer" }}
        onClick={() => {
          setIsServ(!isServ);

          setSelectedList((prev) => {
            const oldList = [...prev];
            if (oldList.includes(index)) {
              return oldList.filter((item) => item !== index);
            }

            setSeletedUnitsObj({
              foodList: foodList,
              selectedList: [...oldList, index],
              setSelectedList: setSelectedList,
              setFoodList: setFoodList,
              cardId: cardId,
            });

            return [...oldList, index];
          });
        }}
      >
        <div
          className={`kitchen-input-checkbox w-fit mt-[3px] mr-[min(1.46vw,15px)] h-fit ${
            isCancel ? "opacity-0" : ""
          }`}
        >
          <input type="checkbox" checked={selectedIndexList.includes(index)} />
          <label></label>
        </div>
        <div
          className={`mr-[min(1.76vw,18px)] text-base font-[500] ${
            selectedIndexList.includes(index) || isCancel ? "line-through" : ""
          } ${info.prevUnit ? "text-[var(--color-red)]" : ""} relative`}
        >
          <div className="text-nowrap">{info.unit} x</div>
          {info.prevUnit && (
            <div
              className="absolute top-[calc(min(0.78vw,8px)*-1)] right-[calc(min(0.59vw,6px)*-1)] text-12 text-black"
              style={{
                textDecoration: "line-through",
                textDecorationColor: "red",
                textDecorationThickness: "1px",
              }}
            >
              {info.originalUnit} x
            </div>
          )}
        </div>
        <div className="flex flex-col gap-[min(0.29vw,3px)]">
          <div
            className={`text-base font-[500] ${
              selectedIndexList.includes(index) || isCancel
                ? "line-through"
                : ""
            }`}
          >
            {info.name}
          </div>
          {info.productType === "BUNDLE" &&
            info.bundleItems &&
            info.bundleItems.length > 0 && (
              <div className="flex flex-col gap-[min(0.20vw,2px)] mt-[min(0.29vw,3px)]">
                {info.bundleItems.map((item, i) => (
                  <div
                    key={i}
                    className="text-12 flex items-center gap-[min(0.39vw,4px)] text-[#2DC76D]"
                  >
                    <span className="font-bold leading-none">•</span>
                    <span
                      className={
                        selectedIndexList.includes(index) || isCancel
                          ? "line-through"
                          : ""
                      }
                    >
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            )}
          {info &&
            info.addOnList &&
            info.addOnList?.map((value, index) => {
              return (
                <div
                  key={index}
                  className="text-12 w-fit h-[min(1.76vw,18px)] px-[min(0.29vw,3px)] text-[var(--color-red)] bg-[var(--color-light-red)] rounded-lg flex items-center"
                >
                  {value}
                </div>
              );
            })}
          {info &&
            info.ignoreList &&
            info.ignoreList?.map((value, index) => {
              return (
                <div
                  key={index}
                  className="text-12 w-fit h-[min(1.76vw,18px)] px-[min(0.29vw,3px)] text-[var(--color-orange)] bg-[var(--color-light-orange)] rounded-[min(0.20vw,2px)] flex items-center"
                >
                  {value}
                </div>
              );
            })}
        </div>
      </div>
      <button
        className={`pointer-events-auto self-start min-w-[20px] max-w-[20px] mt-1 ${
          icon === "/img/icons/icon-serv-grey.svg"
            ? "cursor-default pointer-events-none"
            : "cursor-pointer"
        }`}
        onClick={() => {
          handleClick(info.unit);
        }}
        disabled={icon === "/img/icons/icon-serv-grey.svg"}
      >
        <img
          className={`object-contain aspect-square w-[min(2.13vw,21.82px)] h-fit`}
          src={icon}
          alt=""
        />
      </button>
    </div>
  );
}

function FooterCard({
  selectedList,
  setSelectedList,
  setFoodList,
  checkIsSelectMutiple,
  setModalKitchenCancelOpen,
  foodList,
  isPayment,
  cardId,
  syncAfterHandle,
  setSeletedUnitsObj,
}) {
  const [isClearOpen, setIsClearOpen] = useState(false);
  const [isBtnActive, setIsBtnActive] = useState(false);

  const { businessSlug } = useParams();
  const foodListActive = foodList && foodList.filter((item) => !item.isCancel);
  const dispatch = useDispatch();
  useEffect(() => {
    if (foodListActive?.length === selectedList?.length) {
      return setIsBtnActive(true);
    }
    setIsBtnActive(false);
  }, [selectedList, foodListActive]);
  const handleCompleteAllOrder = async (isCancel) => {
    const orderItemListId = {
      order_item_ids: foodList?.map((item) => item.id),
    };
    setSelectedList([]);
    if (isCancel) {
      await dispatch(
        kitchenHandler.cancelAllOrder(businessSlug, cardId, orderItemListId)
      );
    } else {
      await dispatch(
        kitchenHandler.completedAllOrder(businessSlug, cardId, orderItemListId)
      );
    }
    await syncAfterHandle();
  };
  return (
    <div className="px-[min(1.95vw,20px)] rounded-b-[min(0.39vw,4px)]">
      <div className="relative  ">
        <div className="h-[min(0.10vw,1px)]  w-full bg-[#CECECE]"></div>
        <div className=" pt-[min(0.98vw,10px)]"></div>
        <button
          onClick={() => {
            if (selectedList.length > 0) {
              setSeletedUnitsObj({
                foodList: foodList,
                selectedList: selectedList,
                setSelectedList: setSelectedList,
                setFoodList: setFoodList,
                cardId: cardId,
              });
              setModalKitchenCancelOpen(true);
            }
          }}
          disabled={selectedList?.length === 0}
          className={`mt-[min(0.49vw,5px)] flex justify-between items-center rounded-[min(0.49vw,5px)] min-w-[min(6.54vw,67px)] h-[min(2.44vw,25px)] border-[min(0.10vw,1px)] border-[#CECECE] px-[min(0.49vw,5px)] logout-avarta ${
            selectedList?.length > 0 ? "" : "disabled-btn-grey"
          }`}
        >
          <img
            className="object-contain aspect-square w-[min(1.56vw,16px)] h-fit"
            src="/img/icons/icon-stop-red.svg"
            alt=""
          />
          <div
            className={`${
              selectedList?.length === 0 ? "text-gray-400" : "text-black"
            }`}
          >
            หมด
          </div>
        </button>
        <div className="absolute top-[15px] right-0 z-[99]">
          <div
            className="cursor-pointer"
            onClick={() => setIsClearOpen(!isClearOpen)}
          >
            <img
              className="logout-avartar object-contain aspect-square w-[min(2.83vw,29px)] h-fit"
              src="/img/icons/icon-three-dot-grey.svg"
              alt=""
            />
          </div>

          {isClearOpen && (
            <div className="relative h-0">
              <ClearAllBtn
                cardId={cardId}
                setIsClearOpen={setIsClearOpen}
                handleClick={handleCompleteAllOrder}
                isClearOpen={isClearOpen}
              />
            </div>
          )}
        </div>
      </div>
      <div className="text-center">
        <CustomBtn
          onClick={() => {
            handleCompleteAllOrder(false);
          }}
          className={`leading-[0.8] px-3 text-white font-[400] text-14 min-h-[min(3.51vw,36px)] rounded-[min(0.58vw,6px)] mt-[min(1.56vw,16px)] mb-[min(0.98vw,10px)] ${
            isBtnActive ? "btn-main-active" : "disabled-btn"
          }`}
          btntxt={"เสร็จสิ้นทั้งหมด"}
        />
      </div>
      <div className=" pt-[min(0.98vw,10px)]"></div>
    </div>
  );
}

function ClearAllBtn({ cardId, setIsClearOpen, handleClick, isClearOpen }) {
  return (
    <button
      style={{ userSelect: "none" }}
      className="absolute right-[calc(min(1.95vw,20px)*-1)] top-[min(0.68vw,7px)] text-18 h-[min(4.10vw,42px)] font-[500] text-[#4A4A4A] rounded-[min(0.78vw,8px)] w-[min(19.43vw,199px)] pl-[min(1.37vw,14px)] py-[min(0.88vw,9px)] shadow-logout-avartar bg-white flex items-center gap-[min(1.07vw,11px)] logout-avartar"
      onClick={() => {
        if (isClearOpen) {
          handleClick(true);
          setIsClearOpen(false);
        } else {
          setIsClearOpen(false);
        }
      }}
    >
      <img
        className="aspect-square w-[min(2.34vw,24px)] object-contain"
        src="/img/icons/icon-bin-red.svg"
        alt=""
      />
      <div>ล้างทั้งหมด</div>
    </button>
  );
}
